/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Continue_On_ErrorInputs */

const cs_automation_continue_on_error = /** @type {(inputs: Automation_Continue_On_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokračovat při chybě`)
};

const en_automation_continue_on_error = /** @type {(inputs: Automation_Continue_On_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue on error`)
};

/**
* | output |
* | --- |
* | "Continue on error" |
*
* @param {Automation_Continue_On_ErrorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_continue_on_error = /** @type {((inputs?: Automation_Continue_On_ErrorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Continue_On_ErrorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_continue_on_error(inputs)
	return cs_automation_continue_on_error(inputs)
});